import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { DepotsApi } from './api'

const useCreateDepot = (onSuccess: () => void) => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_create_depot.'

  const queryClient = useQueryClient()

  const onCreateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.SUPPLIERS_ADMIN)
    if (onSuccess) {
      onSuccess()
    }
  }

  const { mutate, isLoading: isLoadingDepot } = useMutation(DepotsApi.createDepot, {
    onSuccess: () => {
      notification.success({
        message: t('New_depot_created_successfully'),
      })
      onCreateSuccess()
    },
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const errorResponse = error.data.error as {
        type: string
        status: number
        message: string
      }
      if (errorResponse.type === 'NO_ACTIVE_ROUTE') {
        const hint =
          errorResponse.message.length > 62
            ? `${t(`${tPreffix}no_active_route_hint`)} ${errorResponse.message.substring(
                62,
                errorResponse.message.length,
              )}`
            : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

        notification.error({
          message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
        })
      } else {
        notification.error({
          message: t('Error,_could_not_create_depot'),
        })
      }
    },
  })

  return {
    createDepot: mutate,
    isLoadingDepot,
  }
}

export { useCreateDepot }
